import React from 'react'

import {ToastProps} from '../models/ToastProps'
import ToastMsg from "../../../ToastMsg";
import ToastPropsStyle from "../../../models/ToastProps";
import colorUtils from "../../../../../colorUtils";

const styleSuccess: ToastPropsStyle = {
    style: {color: colorUtils.theme.green, bgColor: colorUtils.theme.white},
    icon: {color: 'green', ico: 'published_with_changes '},
}

const ToastSuccess = ({
                          className,
                          title,
                          body,
                          showToast = true,
                          closeAction,
                          ...rest
                      }: ToastProps) => {
    return (
        <ToastMsg
            showToast={showToast}
            className="shared-toastSuccess"
            toastStyle={styleSuccess}
            title={title}
            body={body}
            closeAction={() => closeAction && closeAction()}
        ></ToastMsg>
    )
}

export default ToastSuccess
